import { useEffect, useMemo } from "react";
import { Linking, Platform, Pressable, Text } from "react-native";

import { Screen } from "@/components/ui/Screen";
import { ebaySoldsUrlFromQuery } from "@/lib/scan/ebaySolds";

/**
 * `/out/ebay-solds?…` — forwards a web click to an eBay sold-items search, in the browser.
 *
 * A direct link to `ebay.com/sch/*` in iPhone Safari opens the eBay app when it is installed, and
 * the app drops the Sold/Completed filters (TRO-1453), so the customer saw asking prices as sold
 * ones. A same-site tap does not hand off to an app, and neither does a redirect the page makes
 * itself, so the link lands here and this page replaces itself with eBay. The destination is
 * rebuilt from the query by `ebaySoldsUrlFromQuery`, so this is never an open redirect.
 *
 * Public (`isPublicRoutePath`): the storefronts' customers reach it signed out.
 */
export default function EbaySoldsForward() {
  const url = useMemo(
    () => ebaySoldsUrlFromQuery(Platform.OS === "web" ? window.location.search : ""),
    [],
  );
  useEffect(() => {
    // `replace`, so Back from eBay returns to the card, not to this page.
    if (Platform.OS === "web") window.location.replace(url);
  }, [url]);

  return (
    <Screen role="main" className="items-center justify-center gap-3 px-6">
      <Text className="font-body text-sm text-muted-foreground">Opening eBay sold listings…</Text>
      <Pressable
        onPress={() => void Linking.openURL(url)}
        accessibilityRole="link"
        className="min-h-11 justify-center"
      >
        <Text className="font-label text-sm text-primary">Open them yourself</Text>
      </Pressable>
    </Screen>
  );
}
